import ManageCurrency from "../pages/configurations/manageCurrency/ManageCurrency";
import NewCurrency from "../pages/configurations/manageCurrency/NewCurrency";
import EditPaymentType from "../pages/configurations/paymentType/EditPaymentType";
import ManagePaymentType from "../pages/configurations/paymentType/ManagePaymentType";
import NewPaymentType from "../pages/configurations/paymentType/NewPaymentType";
import DetailSchedulerJobs from "../pages/configurations/schedulerJobs/DetailSchedulerJobs";
import ManageSchedulerJobs from "../pages/configurations/schedulerJobs/ManageSchedulerJobs";
import DetailCode from "../pages/configurations/codes/DetailCode";
import EditCode from "../pages/configurations/codes/EditCode";
import ManageCodes from "../pages/configurations/codes/ManageCodes";
import NewCode from "../pages/configurations/codes/NewCode";
import ManageGlobalConfigurations from "../pages/configurations/globalConfiguration/ManageGlobalConfigurations";
import EditGlobalConfiguration from "../pages/configurations/globalConfiguration/EditGlobalConfiguration";
import EditSchedulerJobs from "../pages/configurations/schedulerJobs/EditSchedulerJobs";
import ManageHolidays from "../pages/configurations/manageHolidays/ManageHolidays";
import NewHoliday from "../pages/configurations/manageHolidays/NewHoliday";
import DetailHoliday from "../pages/configurations/manageHolidays/DetailHoliday";
import EditHoliday from "../pages/configurations/manageHolidays/EditHoliday";
import WorkingDays from "../pages/configurations/workdays/WorkingDays";
import ViewHistory from "../pages/configurations/schedulerJobs/ViewHistory";

export default [
  // PAYMENT TYPE
  {
    path: "/manage-payment-type",
    component: ManagePaymentType,
    isProtected: true,
  },
  {
    path: "/edit-payment-type",
    component: EditPaymentType,
    isProtected: true,
  },
  {
    path: "/add-payment-type",
    component: NewPaymentType,
    isProtected: true,
  },

  // CURRENCY
  {
    path: "/manage-currency",
    component: ManageCurrency,
    isProtected: true,
  },

  {
    path: "/add-currency",
    component: NewCurrency,
    isProtected: true,
  },

  // SCHEDULER JOBS

  {
    path: "/manage-scheduler-jobs",
    component: ManageSchedulerJobs,
    isProtected: true,
  },

  {
    path: "/detail-scheduler-jobs",
    component: DetailSchedulerJobs,
    isProtected: true,
  },

  {
    path: "/edit-scheduler-jobs",
    component: EditSchedulerJobs,
    isProtected: true,
  },

  {
    path: "/view-history",
    component: ViewHistory,
    isProtected: true,
  },

  // CODES
  {
    path: "/manage-codes",
    component: ManageCodes,
    isProtected: true,
  },
  {
    path: "/add-code",
    component: NewCode,
    isProtected: true,
  },
  {
    path: "/edit-code",
    component: EditCode,
    isProtected: true,
  },
  {
    path: "/view-code",
    component: DetailCode,
    isProtected: true,
  },

  // GLOBAL CONFIGURATIONS
  {
    path: "/manage-config",
    component: ManageGlobalConfigurations,
    isProtected: true,
  },
  {
    path: "/edit-config",
    component: EditGlobalConfiguration,
    isProtected: true,
  },

  
  // HOLIDAYS
  {
    path: "/manage-holidays",
    component: ManageHolidays,
    isProtected: true,
  },
  {
    path: "/add-holiday",
    component: NewHoliday,
    isProtected: true,
  },

  {
    path: "/detail-holiday",
    component: DetailHoliday,
    isProtected: true,
  },

  {
    path: "/edit-holiday",
    component: EditHoliday,
    isProtected: true,
  },
  {
    path: "/manage-Workingdays",
    component: WorkingDays,
    isProtected: true,
  },
];
